import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <g transform="rotate(180 12 12)">
            <path d="M13.778 15.556V8.444L9.333 12z" />
            <rect x="4" y="4" width="2" height="16" rx="1" />
        </g>
    </svg>
)
